import { Core } from '.generated/templates/Foundation.Core.model';

export const getPageCtaText = (page: Core.BaseTemplates.Routes.Fields.BasePage) => {
  const fields = page?.fields;
  if (!fields) {
    return '';
  }
  return (
    fields.pageCtaTextOverride?.value ||
    fields.navigationTitle?.value ||
    fields.pageTitle?.value ||
    ''
  );
};
